'use strict';

/*exported Configurations */
/*global Container */
function Configurations(containerName) {
  this.containerName = containerName;
  this.container = null;

  this.init();
}

Configurations.prototype = $.extend({}, {
  constructor: 'Configurations',

  //**************************************************************************
  param: function param(param) {
    var _this = this;

    if (_this.container.has(param)) {
      return _this.container.get(param);
    }

    return null;
  },

  setParam: function setParam(param, value) {
    var _this = this;

    _this.container.set(param, value);

    return _this;
  },

  //**************************************************************************
  init: function init() {
    var _this = this;

    _this.container = new Container();
    if (_this.containerName in window) {
      var array = window[_this.containerName];
      _this.container.loadFromArray(array);
    }

  }
});
